import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/inventory/suppliers/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) => api.get(`/inventory/suppliers`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/inventory/suppliers/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/inventory/suppliers`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/inventory/suppliers/${url.id}`, data, config),
    patch: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.patch(`/inventory/suppliers/${url.id}`, data, config),
};

export default requests;
